/**
 * @flow
 * @relayHash 26a32c60dd0f7b3f283751a6db6185d3
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
type TenantLoaderFragment_viewer$ref = any;
export type TenantLoaderRefetchQueryVariables = {|
  first: number,
  offset: number,
  search: string,
|};
export type TenantLoaderRefetchQueryResponse = {|
  +viewer: ?{|
    +$fragmentRefs: TenantLoaderFragment_viewer$ref
  |}
|};
export type TenantLoaderRefetchQuery = {|
  variables: TenantLoaderRefetchQueryVariables,
  response: TenantLoaderRefetchQueryResponse,
|};
*/


/*
query TenantLoaderRefetchQuery(
  $first: Int!
  $offset: Int!
  $search: String!
) {
  viewer {
    ...TenantLoaderFragment_viewer_2pFftX
    id
  }
}

fragment TenantLoaderFragment_viewer_2pFftX on Query {
  tenants(first: $first, offset: $offset, search: $search) {
    edges {
      node {
        id
        name
        firstName
        lastName
        email
      }
    }
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "kind": "LocalArgument",
    "name": "first",
    "type": "Int!",
    "defaultValue": null
  },
  {
    "kind": "LocalArgument",
    "name": "offset",
    "type": "Int!",
    "defaultValue": null
  },
  {
    "kind": "LocalArgument",
    "name": "search",
    "type": "String!",
    "defaultValue": null
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "first",
    "variableName": "first"
  },
  {
    "kind": "Variable",
    "name": "offset",
    "variableName": "offset"
  },
  {
    "kind": "Variable",
    "name": "search",
    "variableName": "search"
  }
],
v2 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "id",
  "args": null,
  "storageKey": null
};
return {
  "kind": "Request",
  "fragment": {
    "kind": "Fragment",
    "name": "TenantLoaderRefetchQuery",
    "type": "Query",
    "metadata": null,
    "argumentDefinitions": (v0/*: any*/),
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "viewer",
        "storageKey": null,
        "args": null,
        "concreteType": "Query",
        "plural": false,
        "selections": [
          {
            "kind": "FragmentSpread",
            "name": "TenantLoaderFragment_viewer",
            "args": (v1/*: any*/)
          }
        ]
      }
    ]
  },
  "operation": {
    "kind": "Operation",
    "name": "TenantLoaderRefetchQuery",
    "argumentDefinitions": (v0/*: any*/),
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "viewer",
        "storageKey": null,
        "args": null,
        "concreteType": "Query",
        "plural": false,
        "selections": [
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "tenants",
            "storageKey": null,
            "args": (v1/*: any*/),
            "concreteType": "TenantNodeConnection",
            "plural": false,
            "selections": [
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "edges",
                "storageKey": null,
                "args": null,
                "concreteType": "TenantNodeEdge",
                "plural": true,
                "selections": [
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "node",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "TenantNode",
                    "plural": false,
                    "selections": [
                      (v2/*: any*/),
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "name",
                        "args": null,
                        "storageKey": null
                      },
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "firstName",
                        "args": null,
                        "storageKey": null
                      },
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "lastName",
                        "args": null,
                        "storageKey": null
                      },
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "email",
                        "args": null,
                        "storageKey": null
                      }
                    ]
                  }
                ]
              }
            ]
          },
          (v2/*: any*/)
        ]
      }
    ]
  },
  "params": {
    "operationKind": "query",
    "name": "TenantLoaderRefetchQuery",
    "id": null,
    "text": "query TenantLoaderRefetchQuery(\n  $first: Int!\n  $offset: Int!\n  $search: String!\n) {\n  viewer {\n    ...TenantLoaderFragment_viewer_2pFftX\n    id\n  }\n}\n\nfragment TenantLoaderFragment_viewer_2pFftX on Query {\n  tenants(first: $first, offset: $offset, search: $search) {\n    edges {\n      node {\n        id\n        name\n        firstName\n        lastName\n        email\n      }\n    }\n  }\n}\n",
    "metadata": {}
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = '4f90bc046719a22647024384dff9c159';
module.exports = node;
